import { Flex as FlexUI } from "@evergis/ui";
import styled from "styled-components";
import { AttributesBlockCheckbox } from "../../../DialogComponents/Attributes/styled";
import { AttributesBlockContainer, Description as DescriptionUI } from "../../../DialogComponents/styled";
import { FieldValue } from "../../../styled";

export const Flex = styled(FlexUI)`
  align-items: center;
`;

export const Container = styled(Flex)`
  justify-content: flex-start;
  width: 100%;
`;

export const Description = styled(DescriptionUI)`
  font: ${({ theme: { fonts } }) => fonts.description};
  margin-right: 1rem;
`;

export const NameContainer = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  margin-left: 1rem;

  > ${Description} {
    margin: 0;
  }
`;

export const AttributeName = styled.div`
  width: 7.5rem;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const PropertiesLabel = styled.span`
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

export const ResourceFieldValue = styled(FieldValue)`
  span:last-child {
    margin-top: 0.625rem;
  }
`;

export const LayerAttributesContainer = styled(AttributesBlockContainer)`
  ${AttributesBlockContainer} {
    background-color: transparent;
    margin-top: 0;

    ${AttributesBlockCheckbox} {
      margin-top: 1rem;
    }
  }
`;

export const MetaRow = styled(Flex)`
  width: 100%;
  margin-top: 1rem;
`;

export const MetaRowItem = styled(FieldValue)`
  flex: 1;
`;
